<script>
export default {
    name: "Partners",
    computed: {
        partnersInfo() {
            return this.$store.state.baseInfo.partners;
        },
        manufacturersInfo() {
            return this.$store.state.baseInfo.manufacturers;
        }
    },
}
</script>

<style scoped>

</style>
